/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Interrupted_PillInputs */



/**
* | output |
* | --- |
* | "Recording interrupted" |
*
* @param {Meeting_Offline_Interrupted_PillInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_interrupted_pill = /** @type {((inputs?: Meeting_Offline_Interrupted_PillInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Interrupted_PillInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opname onderbroken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement interrompu")
	return /** @type {LocalizedString} */ ("Recording interrupted")
});